import { Outlet } from "react-router-dom";

function EmptyLayout() {
  return (
    <div className="bg-light">
      <Outlet />
    </div>
  );
}

export default EmptyLayout;
